import React from 'react';

const InvalidDateParamsErrorModalBody = () => {
  return <div>Invalid date params</div>;
};

export default InvalidDateParamsErrorModalBody;
